import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function Roots() {
  useReveal();
  const { c } = useSite();
  const { roots, brand } = c;
  return (
    <section className="relative py-28 sm:py-44 grain overflow-hidden">
      <div className="absolute inset-0">
        <img src={roots.image} alt="Ancient woods" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[rgba(18,15,11,0.8)]" />
      </div>
      <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <div className="flex items-center justify-center gap-4 mb-7">
          <span className="eyebrow">{roots.label}</span>
        </div>
        <h2 className="reveal font-display text-4xl sm:text-6xl font-light text-[#EFE7D6]">{roots.title}</h2>
        <p className="reveal mt-7 text-xl sm:text-2xl leading-relaxed text-[#EFE7D6]/75 font-light">{roots.text}</p>
        <div className="reveal mt-12 inline-flex flex-col items-center">
          <span className="font-display italic text-3xl text-gold">{brand.motto}</span>
          <span className="font-label text-[0.68rem] uppercase tracking-[0.28em] text-[#EFE7D6]/60 mt-3">
            {brand.mottoEn}
          </span>
        </div>
      </div>
    </section>
  );
}
